export enum HttpStatusCode {
    MAINTENANCE_MODE = 2001,
    REPORTING_ERROR = 400122
}
